const BASE_URL = process.env.REACT_APP_API_URL || 'https://base.techaura.ru';
module.exports = BASE_URL;
